import phone1 from './phone1.png';
import phone2 from './phone2.png';
import phone3 from './phone3.png';
import phone4 from './phone4.png';
import pwd1 from './pwd1.png';
import pwd2 from './pwd2.png';
import pwd3 from './pwd3.png';
import pwd4 from './pwd4.png';
import lptp1 from './lptp1.png';
import spltr from './spltr.png';
import sethusd from './sethusd.png';
import stsla from './stsla.png';
import shood from './shood.png';
import snvda from './snvda.png';
import spy from './spy.png';
import testimonie1 from './testimonie1.png';

const images = {
    phone1: phone1,
    phone2: phone2,
    phone3: phone3,
    phone4: phone4,
    pwd1: pwd1,
    pwd2: pwd2,
    pwd3: pwd3,
    pwd4: pwd4,
    lptp1: lptp1,
    spltr: spltr,
    sethusd: sethusd,
    stsla: stsla,
    shood: shood,
    snvda: snvda,
    spy: spy,
    testimonie1: testimonie1,
}

export default images;